import React from 'react';
import { StatusPending, StatusOK, StatusError, StatusWarning, StatusAborted, StatusRunning } from '@backstage/core-components';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  statusIcon: {
    "& svg": {
      position: "static"
    }
  }
}));
const WorkflowRunStatus = (props) => {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center" }, /* @__PURE__ */ React.createElement(Box, { className: classes.statusIcon }, /* @__PURE__ */ React.createElement(WorkflowIcon, { ...props })), /* @__PURE__ */ React.createElement(Typography, { variant: "body2" }, getStatusDescription(props)));
};
function WorkflowIcon({
  status,
  conclusion
}) {
  if (status === void 0) return null;
  switch (status.toLocaleLowerCase("en-US")) {
    case "queued":
      return /* @__PURE__ */ React.createElement(StatusPending, null);
    case "in_progress":
      return /* @__PURE__ */ React.createElement(StatusRunning, null);
    case "completed":
      switch (conclusion?.toLocaleLowerCase("en-US")) {
        case "skipped":
        case "cancelled":
          return /* @__PURE__ */ React.createElement(StatusAborted, null);
        case "timed_out":
          return /* @__PURE__ */ React.createElement(StatusWarning, null);
        case "failure":
          return /* @__PURE__ */ React.createElement(StatusError, null);
        default:
          return /* @__PURE__ */ React.createElement(StatusOK, null);
      }
    default:
      return /* @__PURE__ */ React.createElement(StatusPending, null);
  }
}
function getStatusDescription({
  status,
  conclusion
}) {
  if (status === void 0) return "";
  switch (status.toLocaleLowerCase("en-US")) {
    case "queued":
      return "Queued";
    case "in_progress":
      return "In progress";
    case "completed":
      switch (conclusion?.toLocaleLowerCase("en-US")) {
        case "skipped":
        case "cancelled":
          return "Aborted";
        case "timed_out":
          return "Timed out";
        case "failure":
          return "Error";
        default:
          return "Completed";
      }
    default:
      return "Pending";
  }
}

export { WorkflowIcon, WorkflowRunStatus, getStatusDescription };
//# sourceMappingURL=WorkflowRunStatus.esm.js.map
